import { normalizeTerm } from "./search-utils";
import { uniqueTerms } from "./search-term-match";

const FALLBACK_POPULAR_TERMS = [
  "성수동 카페",
  "강남역 맛집",
  "연남동 디저트",
  "한남동 브런치",
  "홍대 술집",
  "가산동 점심",
  "을지로 맛집",
  "루프탑 카페",
  "제주 카페",
  "부산 해운대 맛집",
];

// 진짜 검색량이 이만큼은 있어야 「인기 검색어」라고 부른다.
// 그 아래면 「추천 검색어」로 부르고 순위·증감 표시도 감춘다. 예전에는 하나만 있어도
// 「인기」였는데, 실제로는 진짜 3개에 파일에 박아 둔 7개를 섞어 순위를 매기고 있었다.
export const MIN_REAL_POPULAR_TERMS = 5;

export const countRealPopularTerms = (items) =>
  (Array.isArray(items) ? items : []).filter(
    (item) => Number(item?.frequency) > 0
  ).length;

export const hasRealPopularSearches = (items) =>
  countRealPopularTerms(items) >= MIN_REAL_POPULAR_TERMS;

export const normalizePopularSearchItems = (items) => {
  if (!Array.isArray(items)) return [];

  return items
    .map((item, index) => {
      const searchTerm = normalizeTerm(item?.searchTerm || item?.term || item);
      if (!searchTerm) return null;

      return {
        ...item,
        searchTerm,
        rank: Number(item?.rank) || index + 1,
      };
    })
    .filter(Boolean)
    .slice(0, 10);
};

export const buildPopularSearchItems = ({
  popularSearches,
  popularSearchesFetchFailed,
}) => {
  const sourceByTerm = new Map();
  popularSearches.forEach((item) => {
    const term = normalizeTerm(item?.searchTerm);
    if (term) sourceByTerm.set(term.toLowerCase(), item);
  });
  const shouldFillPopularTerms =
    popularSearches.length > 0 || popularSearchesFetchFailed;

  return uniqueTerms([
    ...popularSearches.map((item) => item?.searchTerm),
    ...(shouldFillPopularTerms ? FALLBACK_POPULAR_TERMS : []),
  ])
    .slice(0, 10)
    .map((term, index) => {
      const source = sourceByTerm.get(term.toLowerCase()) || {};
      return {
        searchTerm: term,
        rank: index + 1,
        frequency: Number(source.frequency) || 0,
        trendDirection:
          source.trendDirection || source.direction || source.trend || "same",
        rankChange: source.rankChange ?? source.change ?? source.delta ?? null,
        isNew: Boolean(source.isNew),
      };
    });
};
